var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('el-input',{staticClass:"inline-input",attrs:{"placeholder":_vm.placeTitle},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_c('el-button',{staticClass:"btn",attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }